<template>   <!--计划活动-附件 -->
  <div>
    <el-dialog v-dialogDrag ref="attachmentdialog" :close-on-click-modal="false" width='70%'
    :visible.sync="uploadDialog"  @close="closeDialog" :before-close="beforeClose"
    append-to-body>
      <el-table :data="attachmentData" style="width: 100%">
       <el-table-column prop="filename" label="文件名称" width="180">
       </el-table-column>
       <el-table-column prop="mimeType" label="格式" width="180">
       </el-table-column>
       <el-table-column prop="category" label="类型" width="180">
       </el-table-column>
       <el-table-column prop="size" label="大小">
       </el-table-column>
       <el-table-column label="操作">
         <template slot-scope="scope">
           <el-button size="small" @click="downloadAttachment(scope.row, scope.$index)">下载</el-button>
           <el-button
           size="small"
           @click.native.prevent="deleteAttachment(scope.row, scope.$index, attachmentData)"
           v-show="uploadFormShow">删除</el-button>
         </template>
       </el-table-column>
      </el-table>
      <div>
       <br/>
      </div>
      <el-form :inline="true" ref="attachmentModel" :model="attachmentModel" v-if="uploadFormShow">
        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item :label="$t('m.planActivitySummaryAttachment.data')" prop="data">
              <el-upload
                ref="upload"
                accept=".pdf"
                :limit="limit"
                :headers="{'SUM-TICKET': sumTicket}"
                :action="apiServerUrl"
                :file-list="uploadFileList"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-success="handleSuccess"
                :on-exceed="handleExceed"
                :before-upload="beforeAvatarUpload"
                :on-change="handleChange"
                :on-progress="handleProgress"
                :auto-upload="false"
                :data="attachmentModel">
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button> -->
                <div slot="tip" class="el-upload__tip">只能上传pdf文件，且不超过5mb</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="上传文件类型" required prop="category">
              <el-select style="width: 100%;" v-model="attachmentModel.category">
                <el-option v-for="item in this.attachmentType" :key="item.key" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="uploadFormShow">
        <el-button @click="submitUpload()" type="primary">{{ $t('c.dialog.save') }}</el-button>
        <el-button @click.native="closeDialog()">{{ $t('c.dialog.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getActivityAttachment,
  deleteAttachment
} from '@/views/yourbiz/api/plan/PlanActivity';
import {
  download
} from '@/util/http';
import dateUtil from '../../../common/js/util';
import {
  apiServerUrl
} from '@/bizConfig';
export default {
  components: {

  },
  name: 'orgAttachmentComp',
  // 组件属性对象
  props: {
    attachmentDialogVisible: Boolean,
    // 上传附件form是否展示
    uploadFormShow: Boolean,
    // dataId
    dataId: String,
  },
  // 组件数据对象
  data() {
    return {
      // dataId
    //  dataId: null,
      // 上传附件doalog是否展示
      uploadDialog: false,

      // 附件列表
      uploadFileList: [],
      // 允许上传的附件个数
      limit: 1,
      // 支持文件上传的大小 mb
      fileSize: 5,
      // 文件个数
      fileCount: 0,
      // 上报的api
      apiServerUrl: null,
      // token
      sumTicket: sessionStorage.getItem('token'),
      // 附件提交时携带的表单
      attachmentModel: {
        //source: this.utils.attachmentSource[1].key
      },
      // 附件展示列表
      attachmentData: [],
      //上传附件类型字典
      attachmentType: this.utils.activityAttachmentType,

    };
  },
  // 页面首次加载数据
  mounted() {
    this.uploadDialog = this.attachmentDialogVisible
    this.attachmentData = []
    // 展示附件信息查询
    this.showAttachmentDate()

  },
  methods: {
    // 附件上传方法
    submitUpload() {
      //dateID 不能为空
      if(this.fileCount === 0) {
        this.$message.error('请选择要上传的文件!');
        return false;
      }
      this.attachmentModel.dataId = this.dataId;
      this.attachmentModel.mimeType = 'pdf';
      this.$refs.attachmentModel.validate(valid => {
        if (!valid) {
          this.$message({
            type: 'error',
            message: this.$t('c.form.formMissInfo')
          });
          return;
        }
        this.$refs.upload.submit();
      });
    },
    // 文件下载
    downloadAttachment(row) {
      let json = Object.assign({}, row);
      download(row.namespace + "/attachment/download", json.filename, {'id': json.id});
    },
    // 文件删除
    deleteAttachment(row, index, rows) {
      let json = Object.assign({}, row);
      deleteAttachment({'id': json.id}).then(result => {
        if (result.code == 20000) {
          rows.splice(index, 1);
          return this.$message.success(`文件删除成功`);
        }
      }).catch(() => {
        this.$message.error(`删除数据异常`);
      });
    },
    handleSuccess(response, file, fileList) {
      this.closeDialog();
      return this.$message.success(`上报文件成功`);
    },
    // 删除文件回调
    handleRemove(file, fileList) {
      this.fileCount = fileList.length;
      return this.$message.success(`系统已经移除 ${ file.name } 文件`);
    },

    handleExceed(files, fileList) {
      this.fileCount = this.limit;
      this.$message.warning(`当前限制上传 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    // 点击上传选择文件后校验
    handleChange(file, fileList) {
      const isPDF = file.raw.type === 'application/pdf';
      if (!isPDF) {
        this.$message.error('上传文件类型只能是 pdf 格式!');
        this.$refs['upload'].clearFiles(); // 清空附件list
        return;
      }
      const isLt5M = file.size / 1024 / 1024 < this.fileSize;
      if (!isLt5M) {
        this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
        this.$refs['upload'].clearFiles(); // 清空附件list
        return;
      }
      this.fileCount = fileList.length;
    },
    // 关闭方法
    closeDialog(modified) {
      if (this.beforeCloseCheck()) {
        this.fileCount = 0;
        this.uploadDialog = false;
        // 子组件向父组件绑定的属性传值
        this.$emit('update:attachmentDialogVisible', false)
        return;
      }

      return this.$message.error(`Dialog框关闭失败，请按F5刷新!`);
    },
    // 关闭前检查
    beforeCloseCheck() {
      if(this.uploadFormShow) {
        //this.resetForm("attachmentModel");
        this.$refs['upload'].clearFiles(); // 清空附件list
      }
      this.attachmentData = [];
    // this.dataId = null;
      return true;
    },
    /**
     * 对话框右上角的×关闭前事件
     * @param done 回调关闭方法
     */
    beforeClose(done) {
      if (this.beforeCloseCheck()) {
        done();
      }
    },
    //展示附件数据
    showAttachmentDate() {
      //根据对象类型查询附件列表数据
      this.findAttachment(true)
    },
    // 机构附件查询
    findAttachment(v) {
      if(v){
          this.apiServerUrl = apiServerUrl + '/plan/attachment/upload';
      }
      if (!this.dataId) {
        return;
      }
      getActivityAttachment({
        "dataId": this.dataId,
      }).then(result => {
        if (result.code == 20000 && result.data) {
          result.data.forEach(row => {
            row.size = dateUtil.bytesToSize(row.size);
            row.namespace = "/plan"; // 前台虚拟值 为了方便文件上传下载 判断处理那种附件
            row.category =  dateUtil.findDictItemValueByItemCode(row.category, this.attachmentType);
          });
          this.attachmentData = result.data;
        }
      }).catch(() => {
        return this.$message.error(`数据查询异常`);
      });
    },
    handleProgress(event, file, fileList) {
    },
    handlePreview(file) {
    },
    // ---------------附件
    beforeAvatarUpload(file) {
      const isPDF = file.type === 'application/pdf';
      if (!isPDF) {
        this.$message.error('上传文件类型只能是 pdf 格式!');
        return false;
      }
      const isLt5M = file.size / 1024 / 1024 < this.fileSize;
      if (!isLt5M) {
        this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
        return false;
      }
      return true;
    },
    resetForm(refname) {
      this.$nextTick(() => {
        this.$refs[refname].resetFields();
      });
    },
 }
};
</script>

<style lang="scss">
</style>
